const CONSTANTS = {
    // device types
    ON_DEVICE_TYPES_LIST_IS_LOADING: 'homes/ON_DEVICE_TYPES_LIST_IS_LOADING',
    ON_DEVICE_TYPES_LIST: 'homes/ON_DEVICE_TYPES_LIST'
};

export { CONSTANTS };
